import React from "react";
import { Tabs as AntTabs } from "antd";

export function Tabs({ tabs = [], activeKey, onChange }) {
  const items = tabs.map((tab) => ({ key: tab.key, label: tab.label }));
  return <AntTabs items={items} activeKey={activeKey} onChange={onChange} />;
}

export default Tabs;
